import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Chip } from '@mui/material';
//Danger: Dont change UI without looking for potential breakage at other places
const SmeStatusBadges = ({ badges, selectedKey }) => {
    const selectedBadge = badges.find(badge => badge.key === selectedKey);
    if (!selectedBadge) {
        return null;
    }
    return (_jsx(Chip, { label: selectedBadge.label, color: 'success', style: { backgroundColor: selectedBadge.color, color: 'black', fontWeight: '500', borderRadius: '4px' } }, selectedBadge.key));
};
export default SmeStatusBadges;
